import PageContent from 'pages/MasterCampaignPlanPage/new/components/PageContent'
import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'

import { EuiTabbedContent, EuiLoadingContent, EuiTitle, EuiSpacer } from '@elastic/eui'
import { EuiTabbedContentTab } from '@elastic/eui/src/components/tabs/tabbed_content/tabbed_content'

import { useGetAIPlanBlueprintQuery } from 'api/aiPlanBlueprintsApi'

import AIPlanBlueprintMarketAnalysis from './components/AIPlanBlueprintMarketAnalysis'
import AIPlanBlueprintPersonas from './components/AIPlanBlueprintPersonas'

interface AIPlanBlueprintPreviewPageParams {
  id: string
}

const AIPlanBlueprintPreviewPage: FC = () => {
  const { id } = useParams<AIPlanBlueprintPreviewPageParams>()

  const { data: blueprint, isFetching } = useGetAIPlanBlueprintQuery({ publicId: id ?? '' }, { skip: !id })

  if (!blueprint) {
    if (isFetching) {
      return <EuiLoadingContent />
    }
    return (
      <EuiTitle>
        <h2>Blueprint not found</h2>
      </EuiTitle>
    )
  }

  const getTabFontSize = () => {
    return window.innerWidth > 1102 ? '16px' : '13px'
  }

  const allTabs: EuiTabbedContentTab[] = [
    {
      id: 'market-analysis',
      name: (
        <div style={{ paddingLeft: '.5rem', paddingRight: '.5rem', fontSize: getTabFontSize() }}>
          <div>Analysis & Strategy</div>
        </div>
      ),
      content: (
        <PageContent>
          <AIPlanBlueprintMarketAnalysis blueprint={blueprint} />
        </PageContent>
      )
    },
    {
      id: 'personas',
      name: (
        <div style={{ paddingLeft: '.5rem', paddingRight: '.5rem', fontSize: getTabFontSize() }}>
          <div>Personas</div>
        </div>
      ),
      content: (
        <PageContent>
          <AIPlanBlueprintPersonas blueprint={blueprint} />
        </PageContent>
      )
    }
  ]

  const tabs = allTabs.filter(tab => {
    if (tab.id === 'market-analysis' && blueprint.clientPreviewShowMarketAnalysis === false) return false
    if (tab.id === 'personas' && blueprint.clientPreviewShowPersonas === false) return false
    return true
  })

  return (
    <React.Fragment>
      <Helmet>
        <title>Blueprint - {blueprint.name}</title>
      </Helmet>

      <EuiTitle>
        <h2>{blueprint.name}</h2>
      </EuiTitle>

      <EuiSpacer />

      <EuiTabbedContent tabs={tabs} initialSelectedTab={tabs[0]} />
    </React.Fragment>
  )
}

export default AIPlanBlueprintPreviewPage
